import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../config/axios';
import { handleErrorToast } from '../../CustomFunctions';
import Modal from 'react-bootstrap/Modal';
import { DropdownArrowOption, AddwithWhiteCircle, DocumentIcon, DeleteDustbin, Attachment } from '../../AllSvg';
import { toast, ToastContainer } from "react-toastify";
import { RenderSelectField } from '../../FormdataComponent';
import Select from "react-select";

const ArrowBullet = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 18 14" id="Arrow">
        <g fill="none" fillRule="evenodd" stroke="#2476bd" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            <path d="M1 7h16M11 1l6 6-6 6" fill="#2476bd" />
        </g>
    </svg>
);

const Card = ({
    letter,
    letterNum,
    replyBy,
    letterDate,
    status,
    onToggle,
    isExpanded,
    showToggleAll,
    toggleAllLabel,
    onToggleAll,
    isHighlighted
}) => {
    const [showDetails, setShowDetails] = useState(false);
    return (
        <div style={{ width: 'fit-content', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <div style={{ rotate: isExpanded ? '90deg' : '0deg' }}><ArrowBullet /></div>
            <div style={{ flex: 1, boxSizing: 'border-box', padding: '12px' }}>
                <div
                    style={{
                        display: 'flex',
                        backgroundColor: isHighlighted ? (status === 'pending' ? '#e3f2fd' : '#CFF1CF') : '#f9f9f9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: isHighlighted ? (status === 'pending' ? '0 0 0 2px #1976d2' : '0 0 0 2px green') : 'none',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <div style={{ width: '5px', backgroundColor: status === 'pending' ? '#2576bc' : 'green' }} />
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '12px', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label style={{ fontWeight: 500 }}>Letter Number: {letterNum}</label>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                {onToggle && (
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#2576bc',
                                            cursor: 'pointer',
                                            marginLeft: '15px'
                                        }}
                                        onClick={onToggle}
                                    >
                                        {isExpanded ? 'Hide' : 'View'}
                                    </div>
                                )}
                                {showToggleAll && (
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#2576bc',
                                            cursor: 'pointer'
                                        }}
                                        onClick={onToggleAll}
                                    >
                                        {toggleAllLabel}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '25px', fontSize: '14px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>Reply by:</label>
                                <label>Letter Date:</label>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{replyBy || '-'}</label>
                                <label>{letterDate || '-'}</label>
                            </div>
                        </div>
                        <div onClick={() => setShowDetails(true)} style={{ boxSizing: 'border-box', cursor: 'pointer', padding: '8px', paddingLeft: '0px' }}>Letter Details</div>
                        <UpdateTrackRecordDetailwithIDonly show={showDetails} setShow={setShowDetails} i={letter} projectId={letter.id} workperformedby={letter.workperformedby} letterType={letter.letterType} />
                    </div>
                </div>
            </div>
        </div>
    )
};

const UpdateTrackRecordDetailwithIDonly = ({
    i,
    title,
    getProjects,
    projectList,
    projectId,
    letterType,
    workperformedby,
    associatedletters,
    letterData,
    show,
    setShow
}) => {

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setFormData(i);

        // Trigger the API calls when the modal is shown
        await getLettersByID();
        // await getAsociatedLetters();
    };

    useEffect(() => {
        if (show) {
            handleShow();
        }
    }, [show]);

    const [formData, setFormData] = useState({
        letter_num: "",
        project: projectId ? projectId : "null",
        subject: "",
        letter_date: "",
        status: "",
        workperformedby: workperformedby ? workperformedby : "null",
        lettertype: letterType ? letterType : "null",
        letterExchange: "",
        letter_from: "",
        letter_to: "",
        remarks: '',
        associated_letters: associatedletters ? associatedletters : [],
        associated_letters_status: "pending",
        documents: [
            {
                document_name: null,
                document_file: "",
            },
        ],
        other_type_name: '',

    });
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format




    const [formDataDoc, setFormDataDoc] = useState({
        documents: [
            {
                document_name: null,
                document_file: "",
            },
        ],
    });




    const getLettersByID = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/linked-letter-list/${i.id}/`
            );

            const filteredData = res.data.filter(item => item.id === i.id);
            if (filteredData.length > 0) {
                setFormData(prevState => ({
                    ...prevState,
                    ...filteredData[0], // Merge with existing state
                }));
            }

        } catch (err) {
            handleErrorToast(err);
        }
    };


    const [trackRecordList, setTrackRecordList] = useState([]);
    const getAsociatedLetters = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/letterrecordbyfilters/${formData.project
                }/${formData.workperformedby}/${formData.lettertype
                }`
            );
            setTrackRecordList(res.data);
        } catch (err) {
            // toast.error('Error fetching letters.');
            handleErrorToast(err);
        }
    };

    // useEffect(() => {

    // }, [formData.workperformedby, formData.project]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const requiredFields = [
            // "letter_num",
            // "project",
            // "subject",
            // "letter_date",
            // "status",
            // "lettertype",
            // "workperformedby",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        const newErrors = requiredFields.reduce((acc, field) => {
            if (
                !formData[field] ||
                (Array.isArray(formData[field]) && formData[field].length === 0)
            ) {
                acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
            return acc;
        }, {});

        if (
            formData.associated_letters &&
            formData.associated_letters.length > 0 &&
            !formData.associated_letters_status
        ) {
            newErrors["associated_letters_status"] =
                "Status for associated letters is required!";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // const handleInputChange = (e) => {
    //   const {name, value} = e.target;

    //   setInputState({
    //     ...inputState,
    //     [name]: value.trim() ? "green" : "",
    //   });

    //   setFormData({
    //     ...formData,
    //     [name]: value,
    //   });
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        // if (name === "lettertype") {
        //   if (value === "informative") {
        //     setFormData({
        //       ...formData,
        //       [name]: value,
        //       status: "informative",
        //     });
        //   } else if (value === "show-cause") {
        //     setFormData({
        //       ...formData,
        //       [name]: value,
        //       status: "show-cause",
        //     });
        //   } else {
        //     setFormData({
        //       ...formData,
        //       [name]: value,
        //     });
        //   }
        // } else {
        //   setFormData({
        //     ...formData,
        //     [name]: value,
        //   });
        // }
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const createCustomFile = (originalFile) => {
        const randomCode = generateRandomString();
        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
        const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
        return new File([originalFile], customFileName, {
            type: originalFile.type,
        });
    };

    const generateRandomString = () => {
        const chars =
            "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        return Array.from(
            { length: 8 },
            () => chars[Math.floor(Math.random() * chars.length)]
        ).join("");
    };



    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                const formDataToSend = new FormData();

                // Append general form fields
                Object.keys(formData).forEach((key) => {
                    if (key !== "documents" && formData[key]) {
                        if (key === "associated_letters") {
                            formData[key].forEach((value) =>
                                formDataToSend.append(key, value)
                            );
                        } else {
                            formDataToSend.append(key, formData[key]);
                        }
                    }
                });

                // Append documents data
                formDataDoc.documents.forEach((doc, index) => {
                    const symbols = "!@#$%^&*()_-+=";
                    const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                    const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                    const numbers = "0123456789";
                    const now = new Date();
                    const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
                    const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
                    const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
                    let randomCode = "";

                    // Generate random code for unique filename
                    for (let i = 0; i < 8; i++) {
                        const randomIndex = Math.floor(Math.random() * allChars.length);
                        randomCode += allChars[randomIndex];
                    }

                    const originalFile = doc.document_file;
                    const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                    const customFile = new File([originalFile], customFileName, {
                        type: originalFile.type,
                    });

                    // Check if the document has a valid file before appending
                    if (doc.document_file) {
                        formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);
                        formDataToSend.append(`documents[${index}][document_file]`, customFile);
                    } else {
                        console.warn(`Document file at index ${index} is not valid.`);
                    }
                });
                let res = await axios.put(
                    `${BASE_URL}/siteproject/documentbulkwithletterupdate/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    await getProjects();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const [fileNames, setFileNames] = useState([]);

    const handleDocInputChange = (index, e) => {
        const { name, value, type, files } = e.target;

        setFormDataDoc((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            if (type === "file") {
                newDocuments[index] = {
                    ...newDocuments[index],
                    [name]: files[0],
                };
                setFileNames((prevFileNames) => {
                    const newFileNames = [...prevFileNames];
                    newFileNames[index] = files[0]?.name;
                    return newFileNames;
                });
            } else {
                newDocuments[index] = {
                    ...newDocuments[index],
                    [name]: value.trim() ? value : "",
                };
            }
            return {
                ...prevFormData,
                documents: newDocuments,
            };
        });
    };

    const handleAddDocuments = (e) => {
        e.preventDefault();
        setFormDataDoc((prevFormData) => ({
            ...prevFormData,
            documents: [
                ...prevFormData.documents,
                {
                    document_name: "",
                    document_file: null,
                },
            ],
        }));
    };

    const handleRemoveDocument = (index) => {
        setFormDataDoc((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            newDocuments.splice(index, 1);
            return {
                ...prevFormData,
                documents: newDocuments,
            };
        });
        setFileNames((prevFileNames) => {
            const newFileNames = [...prevFileNames];
            newFileNames.splice(index, 1);
            return newFileNames;
        });
    };

    const handlePicDelete = async (e, i, getProjects) => {
        e.preventDefault();

        setLoading(true); // loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/documents/${i.id}/`
            );

            if (res.status === 200) {
                await getProjects();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false); // loading logic
            toast.dismiss(loadingToastId);
        }
    };

    const options = trackRecordList
        .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
        .map((e) => ({
            value: e.id,
            label: `${e.letter_num} - ${e.letter_date}`,
        }));






    const handleChangecc = (selected) => {
        const associated_letters =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({
            ...prevState,
            associated_letters,
        }));
    };

    // ? Document End ===============================

    useEffect(() => {
        getAsociatedLetters();
    }, [formData.project, formData.workperformedby, formData.lettertype]);

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title ? title : letterData ? "View Associated Letter Details" : "Update Track Details"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div className="form-flex-wrap">
                        <div title="letter ID" className="flex-column">
                            <label
                                htmlFor="letter_num"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter No.<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="letter_num"
                                name="letter_num"
                                placeholder="Letter Number"
                                onChange={handleInputChange}
                                value={formData.letter_num}
                                className={`form-input ${errors.letter_num
                                    ? "error"
                                    : inputState.letter_num
                                        ? "success"
                                        : ""
                                    }`}
                                disabled={letterData}
                            />
                            {errors.letter_num && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_num}
                                </span>
                            )}
                        </div>

                        <div title="Subject" className="flex-column">
                            <label
                                htmlFor="subject"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Subject<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="subject"
                                max={150}
                                name="subject"
                                placeholder="Subject"
                                onChange={handleInputChange}
                                value={formData.subject}
                                disabled={letterData}
                                className={`form-input ${errors.subject
                                    ? "error"
                                    : inputState.subject
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.subject && (
                                <span className="error-message font-size-text ">
                                    {errors.subject}
                                </span>
                            )}
                        </div>

                        <div title="Letter Date" className="flex-column">
                            <label
                                htmlFor="letter_date"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter Date<span className="required">*</span>
                            </label>
                            <input
                                type="date"
                                id="letter_date"
                                name="letter_date"
                                max={today}
                                placeholder="Sent Letter Date"
                                onChange={handleInputChange}
                                value={formData.letter_date}
                                disabled={letterData}
                                className={`form-input ${errors.letter_date
                                    ? "error"
                                    : inputState.letter_date
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.letter_date && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_date}
                                </span>
                            )}
                        </div>

                        <div
                            title="Letter Type"
                            className="flex-column form-group-selectt"
                        >
                            <label
                                htmlFor="lettertype"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter Type<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="lettertype"
                                name="lettertype"
                                placeholder="lettertype"
                                value={formData.lettertype}
                                onChange={handleInputChange}
                                disabled
                                className={`form-input form-group-selection ${errors.lettertype
                                    ? "error"
                                    : inputState.lettertype
                                        ? "success"
                                        : ""
                                    }`}

                            >
                                <option value="null">Select Letter Type</option>
                                <option value="eot">EOT</option>
                                <option value="cos">COS</option>
                                <option value="ncr">NCR</option>
                                <option value="billing">Billing</option>
                                <option value="design">Design</option>
                                <option value="informative">Informative</option>
                                <option value="show-cause">Show Cause</option>
                                <option value="Design & Drawing">Design & Drawing</option>
                                <option value="P&P">P&P</option>
                                <option value="QAP">QAP</option>
                                <option value="Structure">Structure</option>
                                <option value="billing">Billing</option>
                                <option value="Q & ME">Q & ME</option>
                                <option value="BBS">BBS</option>
                                <option value="noc">NOC</option>
                                <option value="Road Safety">Road Safety</option>
                                <option value="Work Plan">Work Plan</option>
                                <option value="Drain">Drain</option>
                                <option value="Hydrology">Hydrology</option>
                                <option value="Survey">Survey</option>
                                <option value="Milestone">Milestone</option>
                                <option value="SiteProgress">SiteProgress</option>
                                <option value="query">Query</option>
                                <option value="other">Others</option>


                            </select>
                            <div className="form-group-selection-arrow">

                            </div>
                            <div>
                                {errors.lettertype && (
                                    <span className="error-message font-size-text ">
                                        {errors.lettertype}
                                    </span>
                                )}
                            </div>
                        </div>


                        <div title="Status" className="flex-column form-group-selectt">
                            <label
                                htmlFor="status"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Status<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="status"
                                name="status"
                                placeholder="Status"
                                disabled={letterData}
                                value={formData.status}
                                onChange={handleInputChange}
                                className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                                    }`}

                            >
                                <option value="">Select a Status</option>
                                <option value="pending">Pending</option>


                                <option value="close">Close</option>

                            </select>


                            <div className="form-group-selection-arrow">

                            </div>

                            <div>
                                {errors.status && (
                                    <span className="error-message font-size-text ">
                                        {errors.status}
                                    </span>
                                )}
                            </div>
                        </div>


                        <div
                            title="Letter Exchange"
                            className="flex-column form-group-selectt"
                        >
                            <label className="form-labels font-weight500 font-size-subheading">
                                Letter Exchange<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="letterExchange"
                                name="letterExchange"
                                value={formData.letterExchange}
                                disabled={letterData}
                                onChange={handleInputChange}
                                className={`form-input form-group-selection ${errors.letterExchange
                                    ? "error"
                                    : inputState.letterExchange
                                        ? "success"
                                        : ""
                                    }`}
                            >
                                <option value="">Select Letter</option>
                                <option value="send">Send</option>
                                <option value="receive">Receive</option>
                            </select>
                            <div className="form-group-selection-arrow">

                            </div>
                            {errors.letterExchange && (
                                <div className="error-message font-size-text">
                                    {errors.letterExchange}
                                </div>
                            )}
                        </div>

                        <div title="Letter From" className="flex-column">
                            <label
                                htmlFor="letter_from"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter From<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="letter_from"
                                max={100}
                                name="letter_from"
                                disabled={letterData}
                                placeholder="Letter From"
                                onChange={handleInputChange}
                                value={formData.letter_from}
                                className={`form-input ${errors.letter_from
                                    ? "error"
                                    : inputState.letter_from
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.letter_from && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_from}
                                </span>
                            )}
                        </div>
                        <div title="Letter To" className="flex-column">
                            <label
                                htmlFor="letter_to"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter To<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="letter_to"
                                max={100}
                                name="letter_to"
                                placeholder="Letter To"
                                disabled={letterData}
                                onChange={handleInputChange}
                                value={formData.letter_to}
                                className={`form-input ${errors.letter_to
                                    ? "error"
                                    : inputState.letter_to
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.letter_to && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_to}
                                </span>
                            )}
                        </div>
                        {letterData ? "" :
                            <>
                                <div className="flex-column">
                                    <label
                                        htmlFor="names"
                                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    >
                                        Associated Letters
                                    </label>
                                    <Select
                                        options={options}
                                        isMulti
                                        onChange={handleChangecc}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '33vw',
                                                height: '50px',
                                                borderRadius: '10px',
                                                border: '1px solid #e3e3e3',
                                                margin: '10px 0px 20px 0px',
                                                color: '#4a4a4a',
                                                backgroundColor: '#f7f8fa',
                                                padding: '0px 10px',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: '33vw',
                                                borderRadius: '10px',
                                                marginTop: '0',
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                        }}
                                    />
                                    {errors.remarks && (
                                        <span className="error-message font-size-text">
                                            {errors.remarks}
                                        </span>
                                    )}
                                </div>
                                {formData.associated_letters &&
                                    formData.associated_letters.length > 0 && (
                                        <RenderSelectField
                                            title="Update Status of Associated Letters"
                                            name="associated_letters_status"
                                            required={true}
                                            options={[
                                                { value: "pending", label: "Pending" },
                                                { value: "close", label: "Close" },
                                            ]}
                                            placeholder="Select Status"
                                            formData={formData}
                                            errors={errors}
                                            inputState={inputState}
                                            handleInputChange={handleInputChange}
                                        />
                                    )}
                            </>
                        }
                    </div>


                    <>

                        <div className="jd-heading-outer  heading-bg-color-white">
                            <div className="jd-heading-outer-flex ">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Documents{" "}
                                </h2>
                                <div>

                                    <button
                                        title="Add Documents"
                                        onClick={handleAddDocuments}
                                        className="jd-heading-main font-weight600 -right-button"
                                        style={{ float: "right", backgroundColor: "#2576bc", color: 'white', borderRadius: '8px', marginRight: '10px', padding: '8px' }}
                                    >
                                        <AddwithWhiteCircle /> Document
                                    </button>

                                    <br />
                                </div>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <table className="table-css">
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="align-left">S. No.</th>
                                        <th className="align-center">Name</th>
                                        <th className="align-center">File</th>

                                        <th className="align-right width-5vw">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.documents?.map((i, index) => (
                                        <React.Fragment key={index}>

                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{i.document_name}</td>

                                                <td className="align-center">
                                                    {i.document_file ? (

                                                        <a href={i.document_file} target="blank">
                                                            <DocumentIcon />
                                                        </a>
                                                    ) : (
                                                        "Document Not Attached"
                                                    )}
                                                </td>

                                                <td className="align-right width-5vw ">
                                                    <button
                                                        className="model-delete-button"
                                                        onClick={(e) =>
                                                            handlePicDelete(e, i, getProjects)
                                                        }
                                                    >
                                                        <DeleteDustbin />
                                                    </button>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <hr className="line" />
                        {!letterData &&
                            <>
                                <div title="Documents" className="">
                                    {/* <label className="form-labels font-weight500 font-size-subheading">Documents</label> */}
                                    {formDataDoc?.documents?.map((doc, index) => (
                                        <div key={index} className="expense-req">
                                            <div className="flex-column field-cont-div">
                                                <label
                                                    htmlFor={`document_name_${index}`}
                                                    className="form-labels announce-date font-weight500 font-size-heading"
                                                >
                                                    File Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`document_name_${index}`}
                                                    name={`document_name`}
                                                    placeholder="Document Name"
                                                    value={doc.document_name}
                                                    onChange={(e) => handleDocInputChange(index, e)}
                                                    className={`form-modal-input ${errors[`document_name_${index}`]
                                                        ? "error"
                                                        : inputState[`document_name`]
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors[`document_name_${index}`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`document_name_${index}`]}
                                                    </span>
                                                )}
                                            </div>

                                            <div className="flex-column field-cont-div">
                                                <label
                                                    htmlFor=""
                                                    className="form-labels announce-date font-weight500 font-size-heading"
                                                >
                                                    Upload File
                                                </label>
                                                <label
                                                    htmlFor={`document_file_${index}`}
                                                    className={`form-inputss custom-file-upload ${errors[`document_file_${index}`]
                                                        ? "error"
                                                        : inputState[`document_file`]
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <div className={`align-center pdf-input  ${errors[`document_file_${index}`] ? 'error' : ''}`}>
                                                        <Attachment />
                                                    </div>
                                                </label>
                                                <input
                                                    id={`document_file_${index}`}
                                                    name={`document_file`}
                                                    type="file"
                                                    onChange={(e) => handleDocInputChange(index, e)}
                                                    style={{ display: "none", position: "relative" }}
                                                />
                                                {fileNames[index] && (
                                                    <p className="file-name align-center">
                                                        {fileNames[index]}
                                                    </p>
                                                )}

                                                {errors[`document_file_${index}`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`document_file_${index}`]}
                                                    </span>
                                                )}
                                            </div>

                                            {index === 0 ? null : (
                                                <button
                                                    type="button"
                                                    className="model-button-cancel"
                                                    onClick={() => handleRemoveDocument(index)}
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className="button-models">
                                    <button
                                        onClick={handleFormSubmit}
                                        className="model-button   font-weight500    model-button-submit"
                                        disabled={loading}
                                        type="submit"

                                    >
                                        {/* //loading logic */}
                                        Update
                                    </button>
                                </div>
                            </>
                        }
                    </>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>


            </Modal>
        </>
    );
};

const LetterNode = ({
    letter,
    node,
    expandedNodes,
    toggleNode,
    showToggleAll,
    toggleAllLabel,
    onToggleAll,
    isRoot = false,
    highlightStatus,
    highlightLetterId,
    isReversed
}) => {
    const isExpanded = expandedNodes.has(node.letter_num);
    const nodeRef = useRef();

    useEffect(() => {
        if (highlightLetterId === node.letter_num && nodeRef.current) {
            nodeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [highlightLetterId]);

    const handleToggle = () => toggleNode(node.letter_num);

    const children = node.associated_letters_hierarchy || [];

    return (
        <div style={{ marginLeft: '20px' }} ref={nodeRef}>
            {!isReversed && (
                <>
                    <Card
                        letter={node}
                        letterNum={node.letter_num}
                        replyBy={node.reply_by}
                        letterDate={node.letter_date}
                        status={node.status}
                        onToggle={children.length ? handleToggle : null}
                        isExpanded={isExpanded}
                        showToggleAll={isRoot && showToggleAll}
                        toggleAllLabel={toggleAllLabel}
                        onToggleAll={onToggleAll}
                        isHighlighted={highlightStatus === node.status || highlightLetterId === node.letter_num}
                    />
                    {isExpanded && children.map((child) => (
                        <LetterNode
                            letter={child}
                            key={child.letter_num}
                            node={child}
                            expandedNodes={expandedNodes}
                            toggleNode={toggleNode}
                            showToggleAll={false}
                            toggleAllLabel={toggleAllLabel}
                            onToggleAll={onToggleAll}
                            highlightStatus={highlightStatus}
                            highlightLetterId={highlightLetterId}
                            isReversed={isReversed}
                        />
                    ))}
                </>
            )}

            {isReversed && (
                <>
                    {isExpanded && children.map((child) => (
                        <LetterNode
                            letter={child}
                            key={child.letter_num}
                            node={child}
                            expandedNodes={expandedNodes}
                            toggleNode={toggleNode}
                            showToggleAll={false}
                            toggleAllLabel={toggleAllLabel}
                            onToggleAll={onToggleAll}
                            highlightStatus={highlightStatus}
                            highlightLetterId={highlightLetterId}
                            isReversed={isReversed}
                        />
                    ))}
                    <Card
                        letter={node}
                        letterNum={node.letter_num}
                        replyBy={node.reply_by}
                        letterDate={node.letter_date}
                        status={node.status}
                        onToggle={children.length ? handleToggle : null}
                        isExpanded={isExpanded}
                        showToggleAll={isRoot && showToggleAll}
                        toggleAllLabel={toggleAllLabel}
                        onToggleAll={onToggleAll}
                        isHighlighted={highlightStatus === node.status || highlightLetterId === node.letter_num}
                    />
                </>
            )}
        </div>
    );
};

const Letter = ({ data }) => {
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const [allNodeIds, setAllNodeIds] = useState(new Set());
    const [highlightStatus, setHighlightStatus] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [highlightLetterId, setHighlightLetterId] = useState(null);
    const [isReversed, setIsReversed] = useState(false);

    useEffect(() => {
        const ids = new Set();
        const collectIds = (node) => {
            ids.add(node.letter_num);
            node.associated_letters_hierarchy?.forEach(collectIds);
        };
        collectIds(data);
        setAllNodeIds(ids);
    }, [data]);

    useEffect(() => {
        if (!searchQuery) {
            setHighlightLetterId(null);
            return;
        }

        const lowerQuery = searchQuery.toLowerCase();
        const expanded = new Set();

        const traverse = (node, parentIds = []) => {
            if (node.letter_num.toLowerCase().includes(lowerQuery)) {
                parentIds.forEach((id) => expanded.add(id));
                setHighlightLetterId(node.letter_num);
            }
            node.associated_letters_hierarchy?.forEach((child) =>
                traverse(child, [...parentIds, node.letter_num])
            );
        };

        traverse(data);
        setExpandedNodes(expanded);
    }, [searchQuery, data]);

    const toggleNode = (id) => {
        setHighlightStatus(null);
        setHighlightLetterId(null);
        setExpandedNodes((prev) => {
            const newSet = new Set(prev);
            newSet.has(id) ? newSet.delete(id) : newSet.add(id);
            return newSet;
        });
    };

    const allExpanded = allNodeIds.size > 0 && allNodeIds.size === expandedNodes.size;

    const toggleAll = () => {
        setHighlightStatus(null);
        setHighlightLetterId(null);
        setExpandedNodes(allExpanded ? new Set() : new Set(allNodeIds));
    };

    const countStatuses = (node) => {
        let pending = 0;
        let close = 0;

        const traverse = (n) => {
            if (n.status === 'pending') pending++;
            if (n.status === 'close') close++;
            n.associated_letters_hierarchy?.forEach(traverse);
        };

        node.associated_letters_hierarchy?.forEach(traverse);
        return { pending, close };
    };

    const { pending, close } = countStatuses(data);

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: 8,
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: '30px'
                }}
            >
                <div style={{ borderRadius: '8px', marginLeft: '50px', boxSizing: 'border-box', padding: '4px', backgroundColor: '#f9f9f9', marginRight: 'auto' }}>
                    <input
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by Letter Number"
                        style={{
                            height: '30px',
                            fontSize: '14px',
                            padding: '0px 5px',
                            borderRadius: '4px',
                            width: '300px',
                            border: 'none',
                            outline: 'none',
                            backgroundColor: '#fff'
                        }}
                    />
                </div>
                <div style={{ marginBottom: '10px', textAlign: 'center' }}>
                    <button
                        onClick={() => {
                            const next = !isReversed;
                            setIsReversed(next);
                            if (next) setExpandedNodes(new Set(allNodeIds)); // expand all on reverse
                        }}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#2576bc',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        {isReversed ? 'Show Parent to Child' : 'Show Child to Parent'}
                    </button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={toggleAll}>
                    <div style={{ height: 15, width: 15, borderRadius: '50%', backgroundColor: '#343a40' }} />
                    <label style={{ color: 'black', cursor: 'pointer' }}>Total ({pending + close})</label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={() => setHighlightStatus(highlightStatus === 'pending' ? null : 'pending')}>
                    <div style={{ height: 15, width: 15, borderRadius: '50%', backgroundColor: '#2576bc' }} />
                    <label style={{ color: 'black', cursor: 'pointer' }}>Pending ({pending})</label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={() => setHighlightStatus(highlightStatus === 'close' ? null : 'close')}>
                    <div style={{ height: 15, width: 15, borderRadius: '50%', backgroundColor: 'green' }} />
                    <label style={{ color: 'black', cursor: 'pointer' }}>Closed ({close})</label>
                </div>
            </div>

            {data.associated_letters_hierarchy?.[0] && (
                <LetterNode
                    letter={data}
                    node={data.associated_letters_hierarchy[0]}
                    expandedNodes={expandedNodes}
                    toggleNode={toggleNode}
                    showToggleAll={true}
                    toggleAllLabel={allExpanded ? 'Hide All' : 'View All'}
                    onToggleAll={toggleAll}
                    isRoot
                    highlightStatus={highlightStatus}
                    highlightLetterId={highlightLetterId}
                    isReversed={isReversed}
                />
            )}
        </div>
    );
};

export default Letter;
